"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALPHA_BaseCarousel = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var CarouselNavigationButtons_1 = require("./carousel-navigation-buttons/CarouselNavigationButtons");
var CarouselList_1 = require("./carousel-list/CarouselList");
var BaseCarousel_module_scss_1 = __importDefault(require("./BaseCarousel.module.scss"));
/**
 * Renders a carousel that displays a list of items.
 * @param {string} id - A unique identifier for the carousel.
 * @param {string} ariaLabel - A descriptive label for accessibility.
 * @param {string} [heading] - An optional title for the carousel.
 * @param {ReactElement} children - A ReactElement representing the items in the carousel.
 * @param {number} numberOfItemsToShow - The number of items to display at once in the carousel.
 * @param {boolean} [showVisibleScrollbar] - A boolean indicating whether to display a visible scrollbar.
 * @param {boolean} [showNavigationControls] - A boolean indicating whether to display navigation controls.
 * @returns {ReactElement} A ReactElement representing the carousel component.
 */
var ALPHA_BaseCarousel = function (_a) {
    var _b;
    var _c;
    var id = _a.id, ariaLabel = _a.ariaLabel, heading = _a.heading, children = _a.children, numberOfItemsToShow = _a.numberOfItemsToShow, _d = _a.showVisibleScrollbar, showVisibleScrollbar = _d === void 0 ? false : _d;
    var items = (_c = react_1.default.Children) === null || _c === void 0 ? void 0 : _c.toArray(children);
    var numberOfPages = Math.ceil((items === null || items === void 0 ? void 0 : items.length) / numberOfItemsToShow);
    var ulContainerElement = (0, react_1.useRef)(null);
    var _e = (0, react_1.useState)(0), currentPage = _e[0], setCurrentPage = _e[1];
    var showNavigationControls = (items === null || items === void 0 ? void 0 : items.length) > numberOfItemsToShow;
    (0, react_1.useEffect)(function () {
        var _a;
        var carouselScroller = ulContainerElement === null || ulContainerElement === void 0 ? void 0 : ulContainerElement.current;
        var observer = new IntersectionObserver(function (observations) {
            var _a, _b, _c, _d, _e, _f;
            for (var _i = 0, observations_1 = observations; _i < observations_1.length; _i++) {
                var observation = observations_1[_i];
                (_b = (_a = observation === null || observation === void 0 ? void 0 : observation.target) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.toggle('--in-view', observation === null || observation === void 0 ? void 0 : observation.isIntersecting);
                if (observation === null || observation === void 0 ? void 0 : observation.isIntersecting) {
                    var currentPageId = +((_c = observation === null || observation === void 0 ? void 0 : observation.target) === null || _c === void 0 ? void 0 : _c.getAttribute('data-pageid'));
                    if (currentPageId === numberOfPages - 1) {
                        var previousPage = (_d = observation === null || observation === void 0 ? void 0 : observation.target) === null || _d === void 0 ? void 0 : _d.previousElementSibling;
                        (_e = previousPage === null || previousPage === void 0 ? void 0 : previousPage.classList) === null || _e === void 0 ? void 0 : _e.remove('--in-view');
                    }
                    setCurrentPage(+((_f = observation === null || observation === void 0 ? void 0 : observation.target) === null || _f === void 0 ? void 0 : _f.getAttribute('data-pageId')));
                }
            }
        }, {
            root: carouselScroller,
            threshold: 0.8,
            rootMargin: "0% -2% 0% -2%",
        });
        (_a = Array.from(carouselScroller === null || carouselScroller === void 0 ? void 0 : carouselScroller.children)) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
            observer === null || observer === void 0 ? void 0 : observer.observe(item);
        });
        return function () {
            observer === null || observer === void 0 ? void 0 : observer.unobserve(carouselScroller);
        };
    }, [numberOfPages, currentPage]);
    var goToPage = function (container, targetElement) {
        var scrollDistance = Math.abs((container === null || container === void 0 ? void 0 : container.offsetLeft) - (targetElement === null || targetElement === void 0 ? void 0 : targetElement.offsetLeft));
        container === null || container === void 0 ? void 0 : container.scrollTo({ left: scrollDistance, behavior: 'smooth' });
    };
    var goNext = function () {
        var _a, _b;
        var current = (_a = ulContainerElement === null || ulContainerElement === void 0 ? void 0 : ulContainerElement.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.--in-view');
        var next = (_b = current === null || current === void 0 ? void 0 : current[0]) === null || _b === void 0 ? void 0 : _b.nextElementSibling;
        if (next) {
            goToPage(ulContainerElement === null || ulContainerElement === void 0 ? void 0 : ulContainerElement.current, next);
        }
    };
    var goPrevious = function () {
        var _a, _b;
        var current = (_a = ulContainerElement === null || ulContainerElement === void 0 ? void 0 : ulContainerElement.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.--in-view');
        var next = (_b = current === null || current === void 0 ? void 0 : current[0]) === null || _b === void 0 ? void 0 : _b.previousElementSibling;
        if (next) {
            goToPage(ulContainerElement === null || ulContainerElement === void 0 ? void 0 : ulContainerElement.current, next);
        }
    };
    var goToNextDirection = function (dir) {
        if (dir === 'right') {
            goNext();
        }
        else if (dir === 'left') {
            goPrevious();
        }
    };
    return (react_1.default.createElement("section", { "aria-label": ariaLabel, "aria-roledescription": "Carousel" },
        react_1.default.createElement("div", { className: (0, classnames_1.default)(BaseCarousel_module_scss_1.default.carousel) },
            react_1.default.createElement("div", { className: (0, classnames_1.default)(BaseCarousel_module_scss_1.default['carousel__header-container'], (_b = {},
                    _b[BaseCarousel_module_scss_1.default['carousel__heading']] = heading,
                    _b)) },
                heading && react_1.default.createElement("h2", { "data-testid": "carousel-heading" }, heading),
                showNavigationControls && (react_1.default.createElement(CarouselNavigationButtons_1.ALPHA_CarouselNavigationButtons, { goToNextDirection: goToNextDirection, currentPage: currentPage, numberOfPages: numberOfPages }))),
            react_1.default.createElement(CarouselList_1.CarouselList, { id: id, showVisibleScrollbar: showVisibleScrollbar, ulContainerElementRef: ulContainerElement, items: items }))));
};
exports.ALPHA_BaseCarousel = ALPHA_BaseCarousel;
//# sourceMappingURL=BaseCarousel.js.map